import React, { useEffect, useState } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { WinterCombosBanner } from './components/WinterCombosBanner';
import { OffersSection } from './components/OffersSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductsSection } from './components/ProductsSection';
import { CombosSection } from './components/CombosSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ShippingSection } from './components/ShippingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { LocationSection } from './components/LocationSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { InstagramButton } from './components/InstagramButton';
export function App() {
  const [activeBrand, setActiveBrand] = useState<string | null>(null);
  useEffect(() => {
    document.title = 'AlphaFit';
  }, []);
  return <div className="min-h-screen bg-dark-900 text-[#f0f0f0] font-sans overflow-x-hidden selection:bg-alphaGold selection:text-white" data-id="element-0" data-mp="6hp9c27i9cj">
      <UrgencyBar data-id="element-1" data-mp="2zmo4r67q0h12" />
      <Navbar onBrandFilter={setActiveBrand} data-id="element-2" data-mp="2zn6actg9w7ln" />
      <main data-id="element-3" data-mp="33m5e4aq9pybi">
        <HeroSection data-id="element-4" data-mp="33nq4rp9gox43" />
        <WinterCombosBanner data-id="element-5" data-mp="33n6wl09m5n39" />
        <OffersSection data-id="element-6" data-mp="33oi0d0326uud" />
        <PainSection data-id="element-7" data-mp="38l8gtoirzsgb" />
        <SolutionSection data-id="element-8" data-mp="38kqgafp2ys2l" />
        <ProductsSection activeBrand={activeBrand} onBrandFilter={setActiveBrand} data-id="element-9" data-mp="38kglmet3bwqk" />
        <CombosSection data-id="element-10" data-mp="3dii3iwes5q0g" />
        <BenefitsSection data-id="element-11" data-mp="nvstj3irmlvf" />
        <ShippingSection data-id="element-12" data-mp="nuhhkgf627t8" />
        <TestimonialsSection data-id="element-13" data-mp="nvarfq9f9dfl" />
        <AboutSection data-id="element-14" data-mp="sunas11342df" />
        <FAQSection data-id="element-15" data-mp="su427axbqqc2" />
        <LocationSection data-id="element-16" data-mp="stc864jdl0nw" />
        <FinalCTA data-id="element-17" data-mp="swqchiblnjxz" />
      </main>
      <Footer data-id="element-18" data-mp="3684vetzoctf" />
      <InstagramButton data-id="element-19" data-mp="35oymvdpbcv8" />
      <ScrollToTop data-id="element-20" data-mp="356r32ll9c80" />
    </div>;
}